module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcforearm2-dfbb1ab2522a45067da5c28a60c12260.jpg";